
import { MemberRole } from '@/types/schema';

// List of paths that are public and don't require authentication
export const PUBLIC_PATHS = ['/create-first-business'];

// Helper to ensure user has required permissions
export const ensureUserHasPermissions = (user: any) => {
  if (!user) return {} as any;
  
  return {
    ...user,
    permissions: user.permissions || [], // Ensure permissions exist
    id: user.id || user.userId || 'unknown', // Ensure id exists
  };
};

// Helper to validate user role
export const getValidRole = (userRole?: string): MemberRole => {
  // Only use a default role if no role is provided at all
  if (!userRole) {
    console.log('No role provided, defaulting to Manager');
    return 'Manager' as MemberRole;
  }
  
  // Check if the provided role is one of our valid roles
  if (userRole === 'Primary Owner' || 
      userRole === 'Owner' || 
      userRole === 'Manager') {
    console.log(`Using valid provided role: ${userRole}`);
    return userRole as MemberRole;
  }
  
  // If the provided role is invalid (but exists), log a warning and default to Manager
  console.warn(`Invalid role provided: ${userRole}, defaulting to Manager`);
  return 'Manager' as MemberRole;
};

// Helper to create enhanced user info
export const createEnhancedUserInfo = (userInfo: any, userId: string): any => {
  // Preserve existing role if present, only validate it
  const validRole = userInfo.role ? getValidRole(userInfo.role) : getValidRole(undefined);
  
  return {
    ...userInfo,
    id: userId,      // Ensure ID is set
    userId: userId,  // Ensure userId is set
    role: validRole, // Use validated role
    permissions: userInfo.permissions || [], // Ensure permissions exist
    status: userInfo.status || 'active', // Ensure status exists
    firstName: userInfo.firstName || '',
    lastName: userInfo.lastName || '',
    email: userInfo.email || '',
    phone: userInfo.phone || ''
  };
};
